import { FC, useEffect, useState } from "react";
import moment from "moment";
import { Box, Container, Flex, Heading, Text, Image, Button, useDisclosure } from "@chakra-ui/react";
import ConfirmDialog from "../../../components/confirm-dialog";
import ProgramService from "../../../services/programs/program-service";
import LogosNotification from "../../../utils/notification-utils";

interface ProgramMemberProps {
    program: any
}

const ProgramMember: FC<ProgramMemberProps> = ({ program }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { isOpen: isShowDeActivateDialog, onOpen: onShowDeActivateDialog, onClose: onCloseDeActivateDialog } = useDisclosure();
    const { isOpen: isShowActivateDialog, onOpen: onShowActivateDialog, onClose: onCloseActivateDialog } = useDisclosure();

    const handleActivateSubscription = () => {
        setIsLoading(true);
        ProgramService.ActivateSubscription(program.userId, program.id).then((res: any) => {
            LogosNotification.Success("Subscription berhasil di aktifkan.");
            window.location.reload();
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const handleDeActivateSubscription = () => {
        setIsLoading(true);
        ProgramService.DeActivateSubscription(program.userId, program.id).then((res: any) => {
            LogosNotification.Success("Subscription berhasil di non-aktifkan.");
            window.location.reload();
        }).finally(() => {
            setIsLoading(false);
        });
    };

    return (
        <Box flex={3} rounded={'lg'} boxShadow={'lg'} border={'1px'} borderColor={"gray.400"}>
            <Box
                maxW={'445px'}
                w={'full'}
                bg={'white'}
                boxShadow={'md'}
                rounded={'md'}
                overflow={'hidden'}>
                <Box
                    pos={'relative'}>
                    <Image
                        src={program.posterUrl}
                    />
                </Box>
                <Flex px={5} py={3}>
                    <Box>
                        <Heading fontSize={'md'}>
                            {program.name}
                        </Heading>
                        <Text fontSize={'sm'} mt={0}>
                            Sejak: {moment(program.subscribedDate).format("DD MMMM yyyy")}
                        </Text>
                        <Text fontSize={'sm'} mt={0}>
                            Aktif?: {program.isActive ? "Aktif" : "Tidak Aktif"}
                        </Text>
                        <Text fontSize={'sm'} mt={0}>
                            Status: {program.isCompleted ? "Sudah Selesai" : "Belum Selesai"}
                        </Text>
                    </Box>
                </Flex>
                <Flex px={5} py={3}>
                    {
                        program.isActive &&
                        <Button variant={'outline'} colorScheme={'red'} isLoading={isLoading} onClick={onShowDeActivateDialog}>Non-aktifkan</Button>
                    }

                    {
                        !program.isActive &&
                        <Button variant={'outline'} colorScheme={'green'} isLoading={isLoading} onClick={onShowActivateDialog}>Aktifkan</Button>
                    }

                    {
                        isShowDeActivateDialog &&
                        <ConfirmDialog
                            title={'Menonaktifkan Subscription'}
                            message={`Apakah Anda yakin untuk menonaktifkan subscription ini?`}
                            colorScheme={'red'}
                            buttonLabel={'Yakin'}
                            onSubmit={handleDeActivateSubscription}
                            onClose={onCloseDeActivateDialog}
                            isLoading={isLoading}
                        />
                    }
                    {
                        isShowActivateDialog &&
                        <ConfirmDialog
                            title={'Aktifkan Subscription'}
                            message={`Apakah Anda yakin untuk Aktifkan subscription ini?`}
                            colorScheme={'green'}
                            buttonLabel={'Yakin'}
                            onSubmit={handleActivateSubscription}
                            onClose={onCloseActivateDialog}
                            isLoading={isLoading}
                        />
                    }
                </Flex>
            </Box>
        </Box>
    );
};

export default ProgramMember;